import { Col as ColAD } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';

import styles from './col.module.css';

type P = {
  alignItems?: 'center' | 'flexEnd' | 'flexStart';
  justifyContent?: 'center' | 'flexEnd';
  textAlign?: 'center' | 'end';
} & ComponentProps<typeof ColAD>;

const Col = ({ alignItems, children, className, justifyContent, textAlign, ...rest }: P) => (
  <ColAD
    className={cn(className, {
      [styles['col--align-items-center'] ?? '']: alignItems === 'center',
      [styles['col--align-items-flex-end'] ?? '']: alignItems === 'flexEnd',
      [styles['col--align-items-flex-start'] ?? '']: alignItems === 'flexStart',
      [styles['col--align-items'] ?? '']: alignItems,
      [styles['col--align-text-center'] ?? '']: textAlign === 'center',
      [styles['col--align-text-end'] ?? '']: textAlign === 'end',
      [styles['col--justify-content-center'] ?? '']: justifyContent === 'center',
      [styles['col--justify-content-flex-end'] ?? '']: justifyContent === 'flexEnd',
      [styles['col--justify-content'] ?? '']: justifyContent,
    })}
    {...rest}
  >
    {children}
  </ColAD>
);

export default Col;
